module.exports = __webpack_public_path__ + "static/media/kevin-healy-Yd2ohmtMmKM-unsplash.e01f282a.jpg";